export type TNullableString = string | null;
export type TNullableNumber = number | null;
export type TNullableBoolean = boolean | null;

export type TUnknownObject = Record<string, any>;

export const GENDER_MALE = 'Male';
export const GENDER_FEMALE = 'Female';

export type TGenderType = typeof GENDER_MALE | typeof GENDER_FEMALE | null;

export const MARITAL_STATUS_SINGLE = 'Single';
export const MARITAL_STATUS_MARRIED = 'Married';
export const MARITAL_STATUS_DIVORCED = 'Divorced';
export const MARITAL_STATUS_WIDOWED = 'Widowed';

export type TMaritalStatus =
  | typeof MARITAL_STATUS_SINGLE
  | typeof MARITAL_STATUS_MARRIED
  | typeof MARITAL_STATUS_DIVORCED
  | typeof MARITAL_STATUS_WIDOWED
  | null;

export const ADDRESS_TYPE_PERMANENT = 'permanent';
export const ADDRESS_TYPE_TEMPORARY = 'temporary';
export const ADDRESS_TYPE_ACTUAL = 'current';
export const ADDRESS_TYPE_WORKING = 'working';

export type TAddressType =
  | typeof ADDRESS_TYPE_PERMANENT
  | typeof ADDRESS_TYPE_TEMPORARY
  | typeof ADDRESS_TYPE_ACTUAL
  | typeof ADDRESS_TYPE_WORKING;

export const LANG_SK_SLUG = 'sk';
export const LANG_EN_SLUG = 'en';

export type TLangSlug = typeof LANG_SK_SLUG | typeof LANG_EN_SLUG;

export const AVAILABLE_LANGUAGES = [LANG_EN_SLUG, LANG_SK_SLUG];
